
import * as DataUtil from "Flow2/components/CustomCollections/CustomDataUtil/CustomDataUtil";
import * as CustomConfig from "Flow2/components/CustomCollections/CustomDataConfig/CustomDataConfig";
import CustomTypes from "Flow2/components/CustomCollections/CustomDataConfig/CustomDataTypes";
import { getApiData } from "Flow2/components/CustomCollections/CustomDataApi/CustomDataApi";
import { isPMDB, isTranscoder1, isMaryTv }
    from 'Flow2/components/CustomCollections/CustomDataControllers/CustomAppController';
import getGrantingForApp from "Flow2/components/CustomCollections/CustomDataControllers/CustomGrantingController";
import { getUserInfos } from "Flow2/components/CustomCollections/CustomDataControllers/CustomUserController";


export const changeFormStyleForApp = (formDesign) => {
    if ((isPMDB() || isTranscoder1() || isMaryTv()) && (formDesign === CustomTypes.UPLOAD_FORM)) {
        return true;
    }
    return false;
}

export const getLeftCountForApp = () => {
    if (isPMDB()) return 1;
    else if (isTranscoder1()) return 3;
    else return 2;
}


export const getFormTabs = (formData) => {
    let tabs = [];
    formData.map(item => {
        if (item.type === "tab") tabs.push({ "name": item.name, "lgMsId": item.name })
    })
    return tabs;
}

const convertMetadataConfig4DropDown = (options, field, user = null) => {
    let data = [];
    let EN = null;
    let RU;
    if (Array.isArray(options) && options.length > 0) {
        options.map(item => {
            let ID = DataUtil.subStringBefore(item, "=");
            let DE = DataUtil.subStringAfter(item, "=");
            EN = DE;
            RU = EN;
            if (ID && DE) {
                if (getGrantingForApp({ user: user, field: field, grantingField: ID }))
                    data.push({ ID, DE, EN, RU });
            }
        })
    }
    return data;
}


export const convertMetaDataForClipInfo = (data) => {
    let customClipInfo = [];
    try {
        Object.keys(data).map(item => {
            if (data[item].field && ((CustomTypes.APP_CLIPID_FIELDS.indexOf(data[item].field) !== -1)
                || (CustomTypes.APP_CREATED_FIELDS.indexOf(data[item].field) !== -1)
                || (CustomTypes.APP_PROD_DATE_FIELDS.indexOf(data[item].field) !== -1))) {

                customClipInfo.push(data[item].field)
            }
        })
    } catch (e) {
        console.log("LAMTEST getClipInfoForApp");
    }

    return customClipInfo;
}

export const findSubMenuData4Form = (formName, formData, submenu, user = null) => {
    let submenuData = [];
    formData.map(item => {
        if (item.tab === submenu && item[formName] === true) {
            let inputType;
            let convertedObj = null;
            let name = item.field;
            let data = null;
            let api = false;
            switch (item.type) {
                case 'text':
                    inputType = "CustomDataInput";
                    if (item.params.datefield && formName === CustomTypes.APP_FORM_SEARCH)
                        inputType = "CustomDateGroup";
                    if (item.params.datefield && formName === CustomTypes.APP_FORM_UPLOAD)
                        inputType = "CustomDateBox";
                    if (name.includes("description"))
                        inputType = "CustomResizableTextArea";
                    break;
                case 'tagtree':
                    inputType = "CustomDropdownWithFadeBox";
                    data = [];
                    break;
                case 'textfield':
                    inputType = "CustomResizableTextArea";
                    break;
                case 'dropdown':
                    inputType = "CustomDropDown";
                    data = convertMetadataConfig4DropDown(item.options, name, user);
                    break;
                default:
                    break;
            }

            if (data || api) convertedObj = { inputType, lgMsId: item.intl, name, data, api };
            else convertedObj = { inputType, lgMsId: item.intl, name };
            if (convertedObj)
                submenuData.push(convertedObj);
        }
    })
    return submenuData;
}

export const addSubmenu4Form = (submenu) => {
    switch (submenu.lgMsId) {
        case 'metadata.tab.history':
            return { "name": "videoDetails", "lgMsId": "data.tab.videoDetails", "data": submenu.data };
        default:
            return submenu;
    }
}


export const setupApiDataForDropDown = (name, data, props) => {
    let lg = DataUtil.getLanguage(props.lg);

    if (isPMDB()) {
        switch (name) {
            case CustomTypes.API_MODELS:
            case CustomTypes.API_TAGS:
                data = getApiData(props[`api${name}`], `${name}`).sort(DataUtil.dynamicSortAndIgnoreCase(lg));
                break;
            case CustomTypes.API_YEAR:
                data = DataUtil.getModelYears() || [];
                break;
            case CustomTypes.API_COUNTRIES:
                data = CustomConfig.countriesArr;
                break;
            case CustomTypes.API_PMDBUSER:
                data = getUserInfos(props.uploaders, lg, "id");
                break;
            case CustomTypes.API_CREATEDBY:
                data = getUserInfos(props.uploaders, lg, "id");
                break;
            case CustomTypes.API_PROJECT:
                data = DataUtil.setInitialObjState("id", "name", props.projects, lg);
                break;
            case CustomTypes.API_ROOM:
                data = DataUtil.setInitialObjState("id", "title", props.rooms, lg);
                break;
        }
    } else if (isTranscoder1() || isMaryTv()) {
        switch (name) {
            case CustomTypes.API_PROJECT:
                data = DataUtil.setInitialObjState("id", "name", props.projects, lg);
                break;
            case CustomTypes.API_ROOM:
                data = DataUtil.setInitialObjState("id", "title", props.rooms, lg);
                break;
        }

    }
    return data;
}

export const initFormDataForApp = (formName, formData, formTabs, user = null) => {
    let formConfig = [];
    if (isPMDB() && CustomTypes.FLEX_APP) {
        if (formName === CustomTypes.APP_FORM_SEARCH) {
            formConfig.push(addSubmenu4Form({ "name": "metaData", "lgMsId": "expertsearch.metadatDataLb", "data": CustomConfig.eSearchBasicData }));
            formConfig.push(addSubmenu4Form({ "name": "advancedData", "lgMsId": "expertsearch.advancedDataLb", "data": CustomConfig.advancedMetadata }));
            formConfig.push(addSubmenu4Form({ "name": "videoDetails", "lgMsId": "expertsearch.videoDetailsLb", "data": CustomConfig.eSearchVideoDetails }));
        } else if (formName === CustomTypes.APP_FORM_UPLOAD) {

            let changedUploadBasic = [...CustomConfig.uploadBasicData];
            changedUploadBasic.push({ inputType: "CustomSubForm", lgMsId: "data.vRightsDefinitionResLb", data: CustomConfig.subRightsForm });
            formConfig.push(addSubmenu4Form({ "name": "metaData", "lgMsId": "upload.masterDataLb", "data": changedUploadBasic }));
            formConfig.push(addSubmenu4Form({ "name": "advancedData", "lgMsId": "upload.optionalDataLb", "data": CustomConfig.uploadadvancedMetadata }));
            formConfig.push(addSubmenu4Form({ "name": "videoDetails", "lgMsId": "upload.VideoDetailsLb", "data": CustomConfig.uploadVideoDetails }));
            formConfig.push(addSubmenu4Form({ "name": "productionData", "lgMsId": "upload.ProductionLb", "data": CustomConfig.uploadProduction }));
            formConfig.push(addSubmenu4Form({ "name": "addToData", "lgMsId": "upload.addToLb", "data": CustomConfig.uploadAddTo }));
        }

    } else {
        if (Array.isArray(formTabs) && formTabs.length > 0) {
            formTabs.map(item => {
                let subMenuData = findSubMenuData4Form(formName, formData, item.name, user);
                if (Array.isArray(subMenuData) && subMenuData.length > 0) {
                    let submenuName = DataUtil.subStringAfter(item.name, "metadata.tab.");
                    formConfig.push(addSubmenu4Form({ name: submenuName, "lgMsId": item.name, "data": subMenuData }));
                }
            })
        }

        if (isTranscoder1() || isMaryTv()) {
            if (formName === CustomTypes.APP_FORM_UPLOAD) {
                formConfig.push(addSubmenu4Form({ "name": "addToData", "lgMsId": "upload.addToLb", "data": CustomConfig.uploadAddTo }));
            }
        }
    }
    return formConfig;
}